import { DragDropContext,Draggable,Droppable,DropResult } from "@hello-pangea/dnd";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import MenuIcon from '@mui/icons-material/Menu';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import { Button,Grid,IconButton,Stack,TextField } from "@mui/material";
import { useContext } from "react";
import { NewFormContext } from "../../../context/NewFormContext";
import { ChecklistSubitem,ChecklistType } from "../../../types/checklist/types";

type props = {
  subitem: ChecklistSubitem;
  itemId: string;
  indexSubitem: number
};

export default function ListaDeTextos({ subitem, itemId, indexSubitem }: props) {
  const { setModelo } = useContext(NewFormContext);

  function handleValue(value: string, index: number) {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem, padraoLista: subitem?.padraoLista?.map((av, ind) =>
                    ind === index
                      ? value
                      : av
                  )
                }
                : subitem
            )
          }
          : item
      )
    }));
  }

  function handleAddItem() {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) => {
              if (subitem.id === indexSubitem) {
                return {
                  ...subitem,
                  padraoLista: [
                    ...(subitem?.padraoLista || []),
                    'novo item',
                  ],
                };

              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function handleRemoveItem() {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((subitem) => {
              if (subitem.id === indexSubitem) {
                return {
                  ...subitem,
                  padraoLista: subitem.padraoLista?.slice(0, -1),
                };

              }
              return subitem;
            }),
          }
          : item
      ),
    }));
  }

  function reorder(list: string[], startIndex: number, endIndex: number) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  function handleDragEnd(result: DropResult) {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      subitem.padraoLista as string[],
      result.source.index,
      result.destination.index
    );

    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens?.map((subitem) =>
              subitem.id === indexSubitem
                ? {
                  ...subitem,
                  padraoLista: items
                }
                : subitem
            )
          }
          : item
      )
    }));
  };

  return (
    <Stack direction='row' justifyContent='flex-start' alignItems='flex-start' width='100%'>
      <Grid container spacing={1} width='100%'>
        <Grid size={4}>
          <Stack direction='column' spacing={1.5} alignItems='center'>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="multiplo">
                {(provided) => (
                  <Stack direction='column' spacing={1.4} {...provided.droppableProps} ref={provided.innerRef} width='100%'>
                    {subitem.padraoLista?.map((value, index) => (
                      <Draggable key={index} draggableId={`${subitem.id}|${index}`} index={index}>
                        {(provided) => (
                          <Stack direction='row' spacing={.5} key={index} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <IconButton>
                              <MenuIcon />
                            </IconButton>
                            <TextField
                              fullWidth
                              value={value}
                              onChange={(eve) => handleValue(eve.target.value, index)} />
                            <IconButton onClick={handleRemoveItem} color="error">
                              <RemoveCircleOutlineRoundedIcon />
                            </IconButton>
                          </Stack>)}
                      </Draggable>
                    ))}
                  </Stack>)}
              </Droppable>
            </DragDropContext>
          </Stack>
        </Grid>
        <Grid size={4}>
          <Stack direction='column' justifyContent='flex-start' alignItems='flex-start'>
            <Button
              onClick={handleAddItem}
              variant="outlined"
              endIcon={<AddCircleOutlineRoundedIcon />}>
              Adicionar valor padrão
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Stack >
  );
}
